import { useSubject } from '@guidedchoice/scrinium';
import { PaymentServices } from '../../data/payment';

export function useDefaultPaymentMethod() {
  const defaultPaymentMethodSubject = useSubject<string>(PaymentServices.DefaultPaymentMethod);
  return defaultPaymentMethodSubject;
}
